// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.batch_status_enum */
var BatchStatusEnum;
(function (BatchStatusEnum) {
    BatchStatusEnum["PLANNED"] = "PLANNED";
    BatchStatusEnum["PRODUCED_AWAITING_CLEARANCE"] = "PRODUCED_AWAITING_CLEARANCE";
    BatchStatusEnum["CLEARANCE_REJECTED"] = "CLEARANCE_REJECTED";
    BatchStatusEnum["CLEARED_FOR_RELEASE"] = "CLEARED_FOR_RELEASE";
    BatchStatusEnum["RELEASED"] = "RELEASED";
    BatchStatusEnum["DISPOSED"] = "DISPOSED";
    BatchStatusEnum["CANCELLED"] = "CANCELLED";
})(BatchStatusEnum || (BatchStatusEnum = {}));
;
export default BatchStatusEnum;
/** Zod schema for batch_status_enum */
export const batchStatusEnum = z.nativeEnum(BatchStatusEnum);
//# sourceMappingURL=BatchStatusEnum.js.map